import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertComponent } from './shared/components/alert/alert.component';
import { AlertService } from './shared/services/alert.service';
import { AsyncPipe } from '@angular/common';
import { SideBarMenuComponent } from './shared/components/side-bar-menu/side-bar-menu.component';
import { AuthService } from './auth/services/auth.service';
import { CommonService } from './shared/services/common.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertComponent, AsyncPipe, SideBarMenuComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'admin-web-angular-19';

  alertService = inject(AlertService);
  authService = inject(AuthService);
  commonService = inject(CommonService);

  showingAlert = computed(() => {
    return this.alertService.alert$;
  });

  isCollapsable = computed(() => {
    return this.commonService.isCollapsable;
  });

  onAlertDimissed() {
    this.alertService.clearAlert();
  }
}
